import * as React from 'react';

export const griefTitle = 'Helping Children with the Loss of an Animal Companion';
export const griefText = <>
	The death of a beloved animal is often a child’s first experience with loss. It is normal for children to experience
	grief that may come and go with different levels of intensity for some time after a pet’s death. It can be
	challenging to parents and caregivers to know what to do for, what to say to, and how to help children who are
	hurting. Lap of Love offers a family and children's pet loss support group that can be booked <a
	href="https://petlosssupportgroupschedule.as.me/?appointmentType=24740911" target="_blank"
	className="inline-link">here</a>.
	Following are a few articles about how best to help a grieving child.
</>;

export const helpingList = [
	{
		url: 'https://vet.osu.edu/vmc/sites/default/files/import/assets/pdf/hospital/companionAnimals/HonoringtheBond/HelpingChildrenCopeFactSheet.pdf',
		title: 'Helping Children Cope with the Serious Illness or Death of an Animal Companion',
		description: 'Includes child-appropriate explanations of euthanasia.'
	},
	{
		url: '/pet-loss-support/children-and-pet-grief-resources/a-veterinarians-perspective-children-and-euthanasia.pdf',
		title: 'A Veterinarian\'s Perspective: Should my child be present for our pet\'s euthanasia?',
		description: ''
	},
	{
		url: '/pet-loss-support/children-and-pet-grief-resources/children-in-grief.pdf',
		title: 'Children in Grief',
		description: ''
	}
];

export const helpingBooksTitle = <>
	<h3 className="rich-text__title">
		Animal Companion Loss Books for Children
	</h3>
</>;
export const helpingBooksList = [
	{
		url: 'https://www.amazon.com/Saying-Goodbye-Lulu-Corinne-Demas/dp/031604749X',
		title: 'Saying Goodbye to Lulu',
		description: 'by Corrine Demas'
	},
	{
		url: 'https://www.amazon.com/Jaspers-Day-Marjorie-Blain-Parker/dp/1550749579/ref=sr_1_2?dchild=1&keywords=jasper%27s+day&qid=1613668447&s=books&sr=1-2',
		title: 'Jasper’s Day ',
		description: 'by Marjorie Blain Parker'
	},
	{
		url: 'https://www.amazon.com/When-Pet-Dies-Fred-Rogers/dp/0698116666/ref=sr_1_1?crid=2SYB58ZUTUZ9S&dchild=1&keywords=when+a+pet+dies+by+mr+rogers&qid=1613668563&s=books&sprefix=When+a+pet+dies%2Cstripbooks%2C210&sr=1-1',
		title: 'When a Pet Dies ',
		description: 'by Fred Rogers'
	},
	{
		url: 'https://www.amazon.com/Tenth-Good-Thing-About-Barney/dp/0689712030/ref=sr_1_1?dchild=1&keywords=the+tenth+good+thing+about+barney&qid=1613668634&s=books&sr=1-1',
		title: 'The Tenth Good Thing About Barney ',
		description: 'by Judith Viorst'
	},
	{
		url: 'https://www.centerforloss.com/bookstore/my-pet-died-a-coloring-book-for-grieving-children/',
		title: 'My Pet Died:  A Coloring Book for Grieving Children ',
		description: 'by Dr. Alan Wolfelt'
	},
];

export const lossBooksTitle = <>
	<h3 className="rich-text__title">
		General Loss Books for Children
	</h3>
</>;
export const lossBooksList = [
	{
		url: 'https://www.amazon.com/Fall-Freddie-Leaf-Story-Life/dp/0943432898/ref=sr_1_1?dchild=1&keywords=the+fall+of+freddy+the+leaf&qid=1613668785&s=books&sr=1-1',
		title: 'The Fall of Freddie the Leaf ',
		description: 'by Leo Buscaglia'
	},
	{
		url: 'https://www.centerforloss.com/bookstore/how-i-feel-a-coloring-book-for-grieving-children/',
		title: 'How I Feel:  A Coloring Book for Grieving Children ',
		description: 'by Dr. Alan Wolfelt'
	},
	{
		url: 'https://www.amazon.com/Waterbugs-Dragonflies-Explaining-Death-Children/dp/082981180X/ref=sr_1_3?crid=1GS4549C40F4P&dchild=1&keywords=waterbugs+and+dragonflies+explaining+death+to+young+children&qid=1613669188&s=books&sprefix=waterbugs%2Cstripbooks%2C221&sr=1-3',
		title: 'Water Bugs and Dragonflies:  Explaining Death to Young Children ',
		description: 'by Doris Stickney'
	},
];

export const helpingAnimalsTitle = 'Helping Animals with the Loss of a Companion';
export const helpingAnimalsText = <>
	<p>
		Just as grief is both a universal and yet individual experience for humans, so it is for animals,
		meaning that while all animals have the ability to grieve, the expression of that grief may vary
		from animal to animal and from loss to loss.
	</p>
	<p>
		However, it is important to be aware that animals have a much healthier, more instinctual relationship to life,
		and thereby to death, than do most humans. Animals don’t have a psychological fear of death.
		In fact, they carry none of the psychological baggage surrounding death that so many humans do.
	</p>
	<p>
		This doesn’t mean that they don’t grieve -- they certainly do. But, it does mean that they don’t create
		psychological suffering for themselves in regards to death via guilt, blame, regret, self-recrimination,
		and fear of the unknown the way that humans can.
	</p>
	<p>
		An animal’s grief experience is a mindful one, always anchored in the present moment rather than
		caught up in regrets about the past or anxiety about the future. In this, animals have a great
		deal to teach humans about grief, just as they do about life.
	</p>
	<p>
		<b>
			If the surviving animal had a close relationship with the newly deceased, you may notice the following grief
			responses:
		</b>
	</p>
	<ul>
		<li>Changes in eating habits</li>
		<li>Changes in sleep patterns</li>
		<li>Retreating from socialization</li>
		<li>Withdraw into solitude</li>
	</ul>
	<p>
		These responses will vary from species to species as well as from animal to animal.
		However, in general, the more social the species, the more likely the animal is to respond to the death
		in a manner clearly recognizable as grieving. And, as with humans, the closer the two individual animals are,
		the more likely it is that the one left behind will grieve.
	</p>
	<p>
		It can help to remember that as a family, you will all be facing the challenge of creating a New Normal
		after your beloved pet’s death. This can be as unsettling, daunting, and even scary for the non-human
		members of your family as it is for the human members. Approaching each other (and yourself) with extra
		patience, kindness, affection, support, and love can help everyone with this transition.
		Doing so in honour of the family member who has died is also one of the best ways to memorialize them.
	</p>
</>;

export const specificInfoTitle = <>
	<h3 className="rich-text__title">
		Following are two documents with information more specific to dogs and to cats:
	</h3>
</>;

export const specificInfoList = [
	{
		url: '/pet-loss-support/children-and-pet-grief-resources/canine-grief.pdf',
		title: 'Canine Grief'
	},
	{
		url: '/pet-loss-support/children-and-pet-grief-resources/feline-grief.pdf',
		title: 'Feline Grief'
	},
];